/* eslint-disable react/require-default-props */
import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { LiquidButtons } from './LiquidButtons';

const Container = styled.div`
  display: inline-block;
  position: relative;
  text {
    font-size: 12px;
    letter-spacing: 1.8px;
    @media (min-width: 768px) {
      font-size: 14px;
      letter-spacing: 2.1px;
    }
  }
`;
const Border = styled.div<{ width: number; height: number; color: string }>`
  position: absolute;
  border: 1px solid ${(p) => p.color};
  border-radius: 100px;
  width: ${(p) => `${p.width - 10}px`};
  height: ${(p) => `${p.height - 10}px`};
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  pointer-events: none;
`;

const TEXT_LENGTH = 16;

export const LiquidButton = ({
  width,
  height,
  color1,
  color2,
  color3,
  text,
  forceFactor,
  layer1Velocity,
  layer2Velocity,
  layer1MouseForce,
  layer2MouseForce,
  layer1ForceLimit,
  layer2ForceLimit,
  hoverFactor,
  textColor,
  fontSize,
  letterSpacing,
}: {
  width: any;
  height: any;
  color1: any;
  color2: any;
  color3: any;
  text: any;
  forceFactor: any;
  layer1Velocity: any;
  layer2Velocity: any;
  layer1MouseForce: any;
  layer2MouseForce: any;
  layer1ForceLimit: any;
  layer2ForceLimit: any;
  hoverFactor: any;
  textColor: any;
  fontSize?: number;
  letterSpacing?: number;
}) => {
  const ulRef = useRef(null);

  useEffect(() => {
    if (ulRef.current) {
      const button = ulRef.current;
      // @ts-ignore
      button.liquidButton = new LiquidButtons(button);
    }
  }, [ulRef]);
  return (
    <Container>
      <Border width={width} height={height} color={textColor} />
      <svg
        // @ts-ignore
        ref={ulRef}
        className="liquid-button"
        data-width={width}
        data-height={height}
        data-color1={color1}
        data-color2={color2}
        data-color3={color3}
        data-text={text?.substring(0, TEXT_LENGTH).toUpperCase()}
        data-force-factor={forceFactor}
        data-layer-1-viscosity={layer1Velocity}
        data-layer-2-viscosity={layer2Velocity}
        data-layer-1-mouse-force={layer1MouseForce}
        data-layer-2-mouse-force={layer2MouseForce}
        data-layer-1-force-limit={layer1ForceLimit}
        data-layer-2-force-limit={layer2ForceLimit}
        data-hover-factor={hoverFactor}
        data-text-color={textColor}
        data-font-size={fontSize}
        data-letter-spacing={letterSpacing}
      />
    </Container>
  );
};
